/*global Modernizr */
/*jslint browser: */

(function() {
  'use strict';

  var lr_name_form = document.getElementById('tec-lobby-registrations-search-name'),
      lr_comp_form = document.getElementById('tec-lobby-registrations-search-comp');

  if(lr_name_form) {
    var field_name_type = lr_name_form.querySelector('#form-name-search-type'),
        field_name_year = lr_name_form.querySelector('#field-name-year'),
        field_name_name = lr_name_form.querySelector('#field-name-name'),
        field_name_filer = lr_name_form.querySelector('#field-name-filer'),
        field_name_client_info = lr_name_form.querySelector('#field-name-client-info');

    field_name_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_lr_name_form();
      } else {
        document.startViewTransition(() => check_lr_name_form());
      }
    });

    setTimeout(function() {
      check_lr_name_form();
    }, 100);
  }

  if(lr_comp_form) {
    var field_comp_type = lr_comp_form.querySelector('#form-comp-search-type'),
        field_comp_year = lr_comp_form.querySelector('#field-comp-year'),
        field_comp_compensation = lr_comp_form.querySelector('#field-comp-compensation'),
        field_comp_location = lr_comp_form.querySelector('#field-comp-location'),
        field_comp_client_info = lr_comp_form.querySelector('#field-comp-client-info');

    field_comp_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_lr_comp_form();
      } else {
        document.startViewTransition(() => check_lr_comp_form());
      }
    });

    setTimeout(function() {
      check_lr_comp_form();
    }, 100);
  }

  function check_lr_name_form() {
    if(field_name_type.value === 'lobbyist_name') {
      tec_search_form_field_show(field_name_year);
      tec_search_form_field_show(field_name_name);
      tec_search_form_field_hide(field_name_filer);
      tec_search_form_field_show(field_name_client_info, false);
    } else if(field_name_type.value === 'client_name') {
      tec_search_form_field_show(field_name_year);
      tec_search_form_field_show(field_name_name);
      tec_search_form_field_hide(field_name_filer);
      tec_search_form_field_hide(field_name_client_info, false);
      field_name_client_info.classList.add('hidden');
    } else if(field_name_type.value === 'filer_id') {
      tec_search_form_field_show(field_name_year);
      tec_search_form_field_hide(field_name_name);
      tec_search_form_field_show(field_name_filer);
      tec_search_form_field_show(field_name_client_info, false);
    } else {
      tec_search_form_field_hide(field_name_year);
      tec_search_form_field_hide(field_name_name);
      tec_search_form_field_hide(field_name_filer);
      tec_search_form_field_hide(field_name_client_info, false);
    }
  }

  function check_lr_comp_form() {
    if(field_comp_type.value === 'compensation') {
      tec_search_form_field_show(field_comp_year);
      tec_search_form_field_show(field_comp_compensation);
      tec_search_form_field_hide(field_comp_location);
      tec_search_form_field_show(field_comp_client_info, false);
    } else if(field_comp_type.value === 'location') {
      tec_search_form_field_show(field_comp_year);
      tec_search_form_field_hide(field_comp_compensation);
      tec_search_form_field_show(field_comp_location);
      tec_search_form_field_show(field_comp_client_info, false);
    } else {
      tec_search_form_field_hide(field_comp_year);
      tec_search_form_field_hide(field_comp_compensation);
      tec_search_form_field_hide(field_comp_location);
      tec_search_form_field_hide(field_comp_client_info, false);
    }
  }
}());
